export default __webpack_public_path__ + "static/media/fasting_whatsnext@2x.e542a9d6.jpg";